// Import react.
import * as React from 'react';
// Import interfaces.
import {
	ISessionTimeLeft,
} from '@app/interfaces';
// Import hooks.
import {
	useAuthenticationContext,
} from '@app/hooks/context';

interface ISessionTimeLeftState {
	sessionTimeLeft: ISessionTimeLeft;
	isSessionAboutToExpire: boolean;
}

interface UseSessionTimeLeftListenerResult {
	sessionTimeMinutesLeft: number;
	sessionTimeSecondsLeft: number;
	totalSecondsLeft: number;
	isSessionAboutToExpire: boolean;
}

const useSessionTimeLeftListener = (): UseSessionTimeLeftListenerResult => {

	// #region variables

	let {
		registerSessionTimeListener
	} = useAuthenticationContext();

	const [sessionTimeLeftState, setSessionTimeLeftState] = React.useState<ISessionTimeLeftState>({
		sessionTimeLeft: {
			sessionTimeMinutesLeft: 0,
			sessionTimeSecondsLeft: 0,
			totalSecondsLeft: 0,
		},
		isSessionAboutToExpire: false,
	});
	
	// #endregion variables

	// #region life-cycle methods.

	React.useEffect(() => {
		registerSessionTimeListener(sessionTimeListener);
	}, []);

	// #endregion life-cycle methods.

	// #region member methods.

	const sessionTimeListener = (sessionTimeLeftResult: ISessionTimeLeft, isSessionAboutToExpireResult: boolean): void => {
		setSessionTimeLeftState((currentSessionTimeLeftState: ISessionTimeLeftState) => {
			return {
				...currentSessionTimeLeftState,
				sessionTimeLeft: sessionTimeLeftResult,
				isSessionAboutToExpire: isSessionAboutToExpireResult,
			};
		});
	}

	// #endregion member methods.

	return {
		sessionTimeMinutesLeft: sessionTimeLeftState.sessionTimeLeft.sessionTimeMinutesLeft,
		sessionTimeSecondsLeft: sessionTimeLeftState.sessionTimeLeft.sessionTimeSecondsLeft,
		totalSecondsLeft: sessionTimeLeftState.sessionTimeLeft.totalSecondsLeft,
		isSessionAboutToExpire: sessionTimeLeftState.isSessionAboutToExpire
	};
}

// Export results.
export {
	UseSessionTimeLeftListenerResult,
};

export default useSessionTimeLeftListener;